import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';


import { IonicModule } from '@ionic/angular';


import {LoginPage} from "./login/login.page";
import {DataStorageService} from "../shared/_services/data-storage.service";
import {TokenStorage} from "../shared/_services/token-storage.service";
import {AuthenticationService} from "../shared/_services/authentication.service";
import {SharedRoutesService} from "../shared/_services/shared-routes.service";
import {AUTH_SERVICE, PROTECTED_FALLBACK_PAGE_URI, ProtectedGuard, PUBLIC_FALLBACK_PAGE_URI} from "ngx-auth";
import {RouterModule} from "@angular/router";
import {SignupPage} from "./signup/signup.page";
import {OnboardingScreenPage} from "./onboarding-screen/onboarding-screen.page";
import {ForgotPage} from "./forgot/forgot.page";
import {ActivatePage} from "./activate/activate.page";
import {ChangePasswordPage} from "./change-password/change-password.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  declarations: [
      LoginPage,
      SignupPage,
      OnboardingScreenPage,
      ForgotPage,
      ActivatePage,
      ChangePasswordPage

  ],
  providers: [
    DataStorageService,
    TokenStorage,
    AuthenticationService,
    SharedRoutesService,
    ProtectedGuard,
    {provide: PROTECTED_FALLBACK_PAGE_URI, useValue: 'private/main/dashboard'}, // redirect if already logged in
    {provide: PUBLIC_FALLBACK_PAGE_URI, useValue: '/authentication/login'}, // redirect if not logged in
    {provide: AUTH_SERVICE, useClass: AuthenticationService}
  ]
})
export class AuthenticationModule {}
